import _ from 'lodash';
import moment from 'moment';
import { useEffect } from 'react';
import {
  CONSTANT,
  canadianNationalHolidays,
  canadianNonQCHolidays,
  PERMISSIONS,
  formCategoryWirelineSecureBusiness,
  formCategoryReferrals
} from './constant';
import request, { apiHost } from './request';

const getValue = value => value || '-';
const { getProfile } = request;
const profile = getProfile();
const permissions = profile ? PERMISSIONS[profile.role.name] : undefined;

const setConstant = (constantKey, data, k) => {
  const tempData = _.keyBy(data, k);
  Object.keys(tempData).forEach(key => {
    CONSTANT[constantKey][key] = tempData[key].id;
  });
};

export const sortedObjects = (arr, name) =>
  arr.sort((a, b) =>
    // eslint-disable-next-line no-nested-ternary
    a[name] > b[name] ? 1 : b[name] > a[name] ? -1 : 0
  );

export { getValue, setConstant };

export const isEmpty = value => {
  return value === undefined || value === null || value === '';
};

export const hasLength = (...args) => {
  const empty = element => !(element && element.length);
  return !args.every(empty);
};

export const getFormattedDate = (dateString, format = 'YYYY-MM-DD') => {
  return moment(dateString).format(format);
};

export const getPdfUrl = (id, locale) =>
  `${apiHost}/orders/${id}/quote-pdf?lang=${locale}`;

export const formatPrice = amount => {
  return (
    (amount < 0 && `-$${(amount && Math.abs(amount).toFixed(2)) || '0.00'}`) ||
    `$${(amount && Math.abs(amount.toFixed(2))) || '0.00'}`
  );
};

export const isJson = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const getDiscountAmountSum = (
  data,
  offerValues,
  excludeValueKey = null
) => {
  return Object.keys(data).reduce((acc, key) => {
    let sum = acc;
    if (excludeValueKey) {
      sum +=
        (offerValues || []).includes(key) && key !== excludeValueKey
          ? data[key]
          : 0;
    } else {
      sum += (offerValues || []).includes(key) ? data[key] : 0;
    }
    return sum;
  }, 0);
};

export const getDisabledDates = date => {
  const day = date.getDay();
  const province = localStorage.getItem('province');
  const holidays =
    province === 'QC' ? canadianNationalHolidays : canadianNonQCHolidays;
  if (day === 0 || day === 6) {
    return false;
  }
  if (holidays.includes(moment(date).format('DD-MM'))) {
    return false;
  }
  return true;
};

export const checkAllowedCategories = (fieldName, channelObj = '') => {
  if (channelObj && channelObj.name) {
    if (
      fieldName === formCategoryWirelineSecureBusiness &&
      channelObj.name === permissions.channels.name
    ) {
      return false;
    }
    if (
      fieldName === formCategoryReferrals &&
      channelObj.name === permissions.channels.name
    ) {
      return true;
    }
  }
  return permissions[fieldName];
};

export const isValidEmail = email => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
};

export const scrollToErrors = errors => {
  let highestErrorElement = null;
  let highestErrorPosition = -1;

  // Iterate over each error key
  Object.keys(errors).forEach(key => {
    const selector = `[name=${key}]`;
    const errorElement = document.querySelector(selector);

    if (errorElement) {
      const position = errorElement.getBoundingClientRect().top;

      // Check if the error is higher on the page than the current highest error
      if (position < highestErrorPosition || highestErrorPosition === -1) {
        highestErrorElement = errorElement;
        highestErrorPosition = position;
      }
    }
  });

  if (highestErrorElement) {
    highestErrorElement.focus();
  }
};

export const useFormikScrollToError = (isSubmitting, isValidating, errors) => {
  useEffect(() => {
    if (isSubmitting && !isValidating) {
      scrollToErrors(errors);
    }
  }, [errors, isSubmitting, isValidating]);
};

export const getFieldValue = (name, fields) => {
  return (fields[name] || {}).value || 0;
};
export const indexToLetter = index => {
  if (index >= 0 && index < 26) {
    return String.fromCharCode('A'.charCodeAt(0) + index);
  }
  return null;
};
